import { useId } from 'react';

/** The id of a drawing's ink gradient, and `ink`, the stroke that paints with it. */
export const useInk = () => {
  const id = `sketch-ink-${useId().replaceAll(':', '')}`;
  return { id, ink: `url(#${id})` };
};
